module.exports = __webpack_public_path__ + "img/zaoyinpaichuLeft.b341cad7.png";